import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Button from 'antd/lib/button'
import 'antd/lib/button/style/css'
import { Link } from 'gatsby'

import PostCard from '../components/PostCard'

const IndexPage = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => {
  const posts = edges
  .filter(edge => !!edge.node.frontmatter.date)
  .map(edge => <PostCard key={edge.node.id} post={edge.node} />)
  return (
    <Layout>
      <div>
        <div align="center">
          <br />
          <img src="/images/logo2.png" width="600px" alt="logo" />
          <p
            style={{
              color: '#3366cc',
              fontSize: 50,
              fontWeight: 'bold',
              fontFamily: 'Lato',
            }}
          >
            組み込みシステム研究室
          </p>
          <h2>広島大学 大学院先進理工系科学研究科／情報科学部</h2>
          <br />
          <div>
            <h2>Contents</h2>
            <Link to="/research">
              <Button
                type="primary"
                size="large"
                icon="right-circle"
                style={{ marginRight: 10 , background: '#3366cc',  borderColor: '#3366cc', fontFamily: 'Lato',}}
              >
                研究内容
              </Button>
            </Link>
            <Link to="/members/members">
              <Button
                type="primary"
                size="large"
                icon="right-circle"
                style={{ marginRight: 10 , background: '#3366cc',  borderColor: '#3366cc', fontFamily: 'Lato',}}
              >
                メンバー
              </Button>
            </Link>
            <Link to="/publication/journals">
              <Button
                type="primary"
                size="large"
                icon="right-circle"
                style={{ marginRight: 10 , background: '#3366cc',  borderColor: '#3366cc', fontFamily: 'Lato',}}
              >
                研究業績
              </Button>
            </Link>
          </div>
          <br /><br />
          <div>
            <h2>Topics</h2>
          {posts}
          </div>
          <img src="/images/emb.png" alt="emb" />

        </div>
      </div>
    </Layout>
  )
}

export default IndexPage


export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { rootPage: { eq: "/article" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            rootPage
          }
        }
      }
    }
  }
`
